import React from "react";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleLoginButton({ next, fullWidth = true, label = "Pokračovať cez Google" }) {
  const { user } = useAuth();
  if (user) return null;

  const onClick = () => {
    const redirectUrl = window.location.origin + "/auth/callback" + (next ? `?next=${encodeURIComponent(next)}` : "");
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      data-testid="google-login-btn"
      onClick={onClick}
      className={`${fullWidth ? "w-full" : ""} inline-flex items-center justify-center gap-3 px-4 py-3 text-sm font-medium border border-zinc-700 bg-zinc-900/40 hover:bg-zinc-800/60 hover:border-zinc-600 transition-colors`}
    >
      <GoogleGlyph />
      <span>{label}</span>
    </button>
  );
}

function GoogleGlyph() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#EA4335" d="M9 3.48c1.69 0 2.85.73 3.5 1.34l2.55-2.49C13.46 1.08 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z"/>
      <path fill="#4285F4" d="M17.64 9.2c0-.63-.06-1.25-.16-1.84H9v3.49h4.84c-.21 1.12-.84 2.07-1.79 2.71l2.89 2.24c1.69-1.56 2.7-3.87 2.7-6.6z"/>
      <path fill="#FBBC05" d="M3.88 10.78A5.5 5.5 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A8.99 8.99 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z"/>
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.89-2.24c-.8.54-1.84.86-3.07.86-2.38 0-4.4-1.57-5.13-3.74L.96 13.04C2.44 15.98 5.48 18 9 18z"/>
    </svg>
  );
}
